var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCounter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "33px",
    viewBox: "0 0 38 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "iconfinder_opened_folder_172515") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Who-We-Are",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD",
    transform: "translate(-459.000000, -448.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconfinder_opened_folder_172515",
    transform: "translate(459.000000, 445.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 38,
    height: 38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,11.5609756 L35,8.53658537 C35,7.70185366 34.3230222,7.02439024 33.4888889,7.02439024 C33.4888889,7.02439024 14.8659556,7.02439024 13.8444444,7.02439024 C12.7345333,7.02439024 11.9676444,4 10.8222222,4 L2.51111111,4 C1.67697778,4 1,4.67746341 1,5.51219512 L1,8.53658537 L1,30.4634146 L1,33.4878049 C1,34.3225366 1.67697778,35 2.51111111,35 L31.9777778,35 C32.8119111,35 33.4888889,34.3225366 33.4888889,33.4878049",
    id: "Path",
    stroke: "#555659",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,33 L4.75,12.5172414 C4.75,11.6797241 5.422,11 6.25,11 L35.5,11 C36.328,11 37,11.6797241 37,12.5172414 L33.25,33",
    id: "Path",
    stroke: "#555659",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounter);
export default __webpack_public_path__ + "static/media/counter.2fddeadc795cf0b360d3d5fa71a20062.svg";
export { ForwardRef as ReactComponent };